import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPolygonMultipleSizeS from './IconPolygonMultiple_size_s';

const props: CreateIconArguments = {
  l: IconPolygonMultipleSizeS,
  m: IconPolygonMultipleSizeS,
  s: IconPolygonMultipleSizeS,
  xs: IconPolygonMultipleSizeS,
  name: 'IconPolygonMultiple',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
